import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { HomeSlice } from "@src/modules/home/typings/slice";
import { SyaratKetentuanGroup } from "../../typings/data";

const initialState: HomeSlice = {
  loadingHome: false,
  errorHome: "",
  dataSK: [],
};

const homeSlice = createSlice({
  name: "home-slice",
  initialState,
  reducers: {
    setLoadingHome(state, action: PayloadAction<boolean>) {
      state.loadingHome = action.payload;
    },
    setErrorHome(state, action: PayloadAction<string>) {
      state.errorHome = action.payload;
    },
    setDataSK(state, action: PayloadAction<SyaratKetentuanGroup[]>) {
      state.dataSK = action.payload;
    },
  },
});

export const { setLoadingHome, setErrorHome, setDataSK } = homeSlice.actions;

export default homeSlice;
